import { css } from 'styled-components'

type Ease = [number, number, number, number]

const easeValues = {
  in: [0.55, 0.06, 0.68, 0.19] as Ease,
  out: [0.22, 0.61, 0.36, 1] as Ease,
  inOut: [0.46, 0.03, 0.52, 0.96] as Ease,
}

export const theme = {
  colors: {
    background: '#FFFFFF',
    text: '#102C44',
    theme: '#2D1996',
    primary: '#A0157F',
    secondary: '#FFEDF4',
    link: '#FFE9A8',
    success: '#5BCCA3',
  },
  fonts: {
    base: '"Roboto Condensed", sans-serif',
    headings: '"Roboto Condensed", sans-serif',
    box: '"Roboto", sans-serif',
  },
  shadow: (offsetY = '0rem', opacity = 36) => css`
    box-shadow: 1.5rem calc(1.5rem + ${offsetY}) 2rem -2rem rgb(0 0 0 / ${opacity}%);
  `,
  easeValues,
  ease: Object.keys(easeValues).reduce(
    (acc, key) => ({
      ...acc,
      [key]: `cubic-bezier(${easeValues[key as keyof typeof easeValues].join(
        ', '
      )})`,
    }),
    { in: '', out: '', inOut: '' }
  ),
}
